import { jsx as _jsx } from "react/jsx-runtime";
const CompanyImage = ({ image, hide }) => {
    return (_jsx("div", { className: "categories__image categories__image--renter", children: hide ? (_jsx("img", { src: image, alt: "", className: "faded_blocked" })) : (_jsx("img", { src: image, alt: "" })) }));
};
export default CompanyImage;
